// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import styles from './BoldButton.module.scss'

export const BoldButton = ({
  label,
  icon,
  isIconFirst = false,
  isPrimary = true,
  width = 'fit-content',
  onClick,
  className = undefined,
}) => {
  const iconImg = <img src={icon} alt="button icon" />

  return (
    <div
      className={cx(className, styles.container, {
        [styles.primary]: isPrimary,
      })}
      style={{ [`width`]: width }}
      onClick={onClick}
    >
      {isIconFirst && icon ? iconImg : null}
      <span className={styles.label}>{label}</span>
      {!isIconFirst && icon ? iconImg : null}
    </div>
  )
}
